import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ConnectButton } from '@rainbow-me/rainbowkit';

const PLAN_OPTIONS = [1, 5, 10, 15, 20, 25, 30];
const MIN_AMOUNT = 5;

const StickyDepositBar = () => {
  const { t } = useTranslation();
  const [heroOut, setHeroOut] = useState(false);
  const [footerIn, setFooterIn] = useState(false);
  const [amount, setAmount] = useState('100');
  const [plan, setPlan] = useState(30);
  const [dismissed, setDismissed] = useState(false);

  // Show bar once Hero leaves viewport
  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const obs = new IntersectionObserver(
      ([entry]) => setHeroOut(!entry.isIntersecting),
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );
    obs.observe(hero);
    return () => obs.disconnect();
  }, []);

  // Hide bar when footer enters viewport
  useEffect(() => {
    const footer = document.querySelector('footer.footer');
    if (!footer) return;
    const obs = new IntersectionObserver(
      ([entry]) => setFooterIn(entry.isIntersecting),
      { threshold: 0, rootMargin: '0px 0px -120px 0px' }
    );
    obs.observe(footer);
    return () => obs.disconnect();
  }, []);

  const visible = heroOut && !footerIn;
  if (dismissed || !visible) return null;

  const amountNum = Number(amount);
  const canStake = Number.isFinite(amountNum) && amountNum >= MIN_AMOUNT;

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="sdb" role="region" aria-label="Quick stake bar">
      <div className="sdb__inner">
        <button
          type="button"
          className="sdb__close"
          onClick={() => setDismissed(true)}
          aria-label="Hide quick stake bar"
        >
          <i className="fas fa-times" />
        </button>

        <div className="sdb__field sdb__field--amount">
          <span className="sdb__label mono">{t('sticky.amount')}</span>
          <div className="sdb__amount-wrap">
            <span className="sdb__prefix">$</span>
            <input
              type="number"
              className="sdb__input mono tabular-nums"
              value={amount}
              min={5}
              onChange={(e) => setAmount(e.target.value)}
            />
            <span className="sdb__suffix mono">USDT</span>
          </div>
        </div>

        <div className="sdb__field sdb__field--plan">
          <span className="sdb__label mono">{t('sticky.plan')}</span>
          <select
            className="sdb__select mono"
            value={plan}
            onChange={(e) => setPlan(Number(e.target.value))}
          >
            {PLAN_OPTIONS.map((d) => (
              <option key={d} value={d}>
                {d} {t('strategies.days')}
              </option>
            ))}
          </select>
        </div>

        <div className="sdb__cta">
          <ConnectButton.Custom>
            {({ account, openConnectModal, mounted }) => {
              if (!mounted) return null;
              if (!account) {
                return (
                  <button
                    type="button"
                    className="tg-btn sdb__btn"
                    onClick={openConnectModal}
                    disabled={!canStake}
                  >
                    {t('sticky.connect')}
                    <i className="fas fa-arrow-right" />
                  </button>
                );
              }
              return (
                <button
                  type="button"
                  className="tg-btn sdb__btn"
                  onClick={() => scrollToSection('strategies')}
                  disabled={!canStake}
                >
                  {t('sticky.stake')}
                  <i className="fas fa-arrow-right" />
                </button>
              );
            }}
          </ConnectButton.Custom>
        </div>
      </div>
    </div>
  );
};

export default StickyDepositBar;
